<template lang="html">
    <div class="regulation">
        <h2>{{getTextArray('motor_nav')[2][getLangage]}}</h2>
        <div class="select-regulation">
            <el-form-item prop="regulation_type" :show-message="showMessage('regulation_type')">
                <el-row :gutter="24">
                    <el-col
                        v-for="type in generateRegulation"
                        :key="type"
                        class="card"
                        :xs="12"
                        :sm="8"
                        :md="6"
                    >
                        <el-card v-if="type != 'no_adjustment'" class="card-1-cta content" @click="setRegulationType(type)">
                            <div slot="header" :class="{'selected': isSelectedType(type)}" @click="setRegulationType(type)">
                                <p class="cardTitle">{{getTranslation(type)}}</p>
                            </div>
                            <div
                                @click="setRegulationType(type)"
                                class="image-container"
                                :style="{backgroundImage: getImageSrc(type)}"
                            >
<!--                                 <img v-if="getImageSrc(type) != ''" :src="getImageSrc(type)" alt="image" :class="{speedVariationImage: type == 'electronic_speed_variation'}">
 -->                                <p v-if="getImageSrc(type) === ''" class="info">{{getText('motor_form_regulation_type_image_not_available')}}</p>
                            </div>
                        </el-card>
                        <el-card v-else class="card-1-cta content" :class="{'selected': isSelectedType(type)}" @click="setRegulationType(type)">
                            <div @click="setRegulationType(type)" class="noSettings" :class="{'selected': isSelectedType(type)}">
                                <p :class="{'selected': isSelectedType(type)}" class="noSettings">{{getTranslation(type)}}</p>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>

            </el-form-item>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            msg: '',
            factory: {},
        };
    },
    props: {
        factoryEngine: {
            type: Object,
            required: true
        },
    },
    computed: {
        ...mapGetters([
            'getText',
            'getTextArray',
            'getLangage',
        ]),
        generateRegulation() {
            let regulation = this.$store.state.regulations[this.factoryEngine.application_type];
            if (regulation.length === 1) {
                this.setRegulationType(regulation[0]);
            }
            return regulation;
        },

    },
    methods: {
        getImageSrc(type) {
            return `url("/static/img/${this.$store.state.img[type]}")`;
        },
        getButtonContent(type) {
            return (this.factoryEngine.regulation_type == type) ? this.getText('selected_button') : this.getText('select_button');
        },
        showMessage(el) {
            if (this.factoryEngine[el].length)
                return true;
            return false;
        },
        setRegulationType(typeuid) {
            this.factoryEngine.regulation_type === typeuid ? this.factoryEngine.regulation_type = '' : this.factoryEngine.regulation_type = typeuid;
        },
        isSelectedType(typeuid) {
            return (this.factoryEngine.regulation_type == typeuid) ? true : false;
        },
        getTranslation(type) {
            return this.$store.state.trad[type][this.getLangage];

        }
    }
};
</script>

<style lang="less">
@import '../../../less/variables';

// .regulation-type-desc {
//     img {
//         margin-bottom: 20px !important;
//     }
//     margin-bottom: 20px !important;
//     font-size: 16px !important;
// }
.regulation {
    border: 5px solid #efefef !important;
    padding: 5px 0;
    .select-regulation {
        @media @desktop {
            width: 80%;
            margin: auto;
            margin-top: 40px;
        }
    }
    .el-row {
        margin: 0 !important;
        flex-wrap: wrap;
    }
    .el-form-item {
        width: 100%;
    }
    .card {
        height: 200px;
        margin-bottom: 20px;
        .el-card__header {
            position: relative;
            z-index: 1;
            padding: 0;
            p {
                padding: 10px;
            }
        }
        .el-card__body {
            height: calc(100% - 45px);
            padding: 10px;
            .image-container {
                cursor: pointer;
                height: 100%;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
            }
        }
        .speedVariationImage {
            max-height: 30%;
            width: auto;
            top: 50%;
            left: 35%;
            @media (min-width: 591px) {
                max-height: 50%;
                width: auto;
                left: 35%;
            }
            @media (min-width: 768px) {
                max-height: 30%;
                width: auto;
                top: 50%;
                left: 35%;
            }
            @media (min-width: 1450px) {
                max-height: 50%;
                width: auto;
                left: 35%;
            }
        }
    }
    .content {
        text-align: center;
        .cardTitle {
            text-transform: uppercase;
            font-size: 16px;
            margin: 0;
            padding: 10px 0;
            line-height: 24px;
            font-weight: 600;
            color: @color-1;
        }
        .info {
            padding: 0 10px;
            color: @color-1;
            font-size: 20px;
            margin: 20px 0 20px !important;
            line-height: 30px;
        }
        .noSettings {
            width: 100%;
            height: 100%;
            font-size: 24px;
            line-height: 36px;
            color: @color-1;
            margin: auto;
            padding-top: 30px;
        }
        .cardTitle:hover, .info:hover, .noSettings:hover {
            cursor: pointer;
        }
    }
}

.selected {
    background-color: @color-1 !important;
    color: white !important;
    .cardTitle {
        color: white !important;
    }
}
.becomeBrighter {
    opacity: 0.7;
}
// .none {
//     width: auto;
//     height: 80px !important;
// }

.regulationButton {
    margin-top: 20px;
    font-size: 15px;
    // overflow-wrap: break-word;
    // word-break: break-word;
    border: none;
    text-transform: uppercase;
    font-family: worksans, Arial, "Helvetica Neue", Helvetica, sans-serif;
    line-height: 18px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 5px 0px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 3px 1px -2px;
    padding: 15px 30px 10px;
    background: @color-1;
    color: white;

}

.regulationButton:hover, .regulationButton:focus {
    background: @color-1;
    color: white;
}



</style>



// WEBPACK FOOTER //
// src/components/partials/wizzard/RegulationForm.vue